import clx from 'classnames'
import { FormRow } from '../../Form'
import styles from './FormRow.css'

const DashboardFormRow = ({ className, children, ...props }) => {
  return (
    <FormRow
      className={clx(className, styles.row)}
      {...props}
    >
      {children}
    </FormRow>
  )
}

export default DashboardFormRow
